import { useEditItem2 } from "../../../toolympus/api/useNewItem";
import { useThrottledCapture } from "../../../toolympus/components/primitives";
import { usePagedLoadedData } from "../../../toolympus/hooks/useLoadedData";

export interface IFullSearchResult {
  _id: number;
  title: string;
  record_type: string;
}

export const useFullSearch = () => {
  const form = useEditItem2<{ filter: string }>({
    save: async (item) => {
      return item;
    }
  });

  const searchCaptured = useThrottledCapture(form.item?.filter || "", 500);

  const items = usePagedLoadedData<IFullSearchResult>(`/api/search/editor?search=${searchCaptured}`, [], !!searchCaptured);

  return {
    form,
    start: () => form.startEditing({ filter: "" }),
    items,
  }
}

export type FullSearchData = ReturnType<typeof useFullSearch>;


export const RecordTypePrefixMap: Record<string, string> = {
  case_record: "case",
  cop_decision: "cop-decision",
  instrument: "instrument",
};

export const RecordTypeLabelMap: Record<string, string> = {
  case_record: "Case",
  cop_decision: "COP Decision",
  instrument: "Instrument",
};


export const itemLink = (item: IFullSearchResult, tab?: string): string => {
  const prefix = RecordTypePrefixMap[item.record_type];
  
  if (!prefix) {
    return "";
  }

  const url = `/${prefix}/${item._id}`;
  
  return tab ? `${url}?tab=${tab}` : url;
}
